
import { useForm, SubmitHandler, Controller } from "react-hook-form"
import Modal from "@/common/components/Modal"
import { Dispatch } from "react"
import TextField from "@/common/components/TextField"
import { ProductPriceEditType } from "@/common/types/productPriceEdit"
import { useUpdateEstablishmentProduct } from "../../hooks/useUpdateEstablishmentProduct"
import { FormTransformers } from "@/common/utils/formTransformers"
import { useQueryClient } from "@tanstack/react-query"
import { EstablishmentProductPricesForm } from "../../types/establishmentProductPricesForm.types"
import { CurrencyTextField } from "@/common/components/CurrencyTextField"
import { zodResolver } from "@hookform/resolvers/zod"
import { updateEstablishmentProductSchema } from "@/features/establishments/schemas/updateProduct.schema"


type Props = {
  isModalVisible:boolean;
  setIsModalVisible:Dispatch<boolean>;
  productPriceToEdit?:ProductPriceEditType;
}


const ModalToEditProduct = ({isModalVisible, setIsModalVisible, productPriceToEdit}:Props) => {
  const { control, handleSubmit, formState: { errors }, setError } = useForm<EstablishmentProductPricesForm>({
    resolver: zodResolver(updateEstablishmentProductSchema)
  });
  const queryClient = useQueryClient();
  const { mutate: updateProduct } = useUpdateEstablishmentProduct({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentProducts'] })
      setIsModalVisible(false);
    },
    onError: FormTransformers.errorsTransformer<EstablishmentProductPricesForm>({ setError }),
  });

  const onSubmit: SubmitHandler<EstablishmentProductPricesForm> = (data) => {
    (data as any)['id'] = productPriceToEdit?.id;
    updateProduct(data);
  };


  return (
    <Modal
      isOpen={isModalVisible}
      setIsOpen={setIsModalVisible}
      title="Ajuste de preço"
      footer="Confirmar ajuste e salvar alteração"
      dataTestid="submit_button"
      onConfirm={handleSubmit(onSubmit)}
      body={(
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
          <TextField
            className="text-white-800 pointer-events-none opacity-80"
            label="Produto"
            value={productPriceToEdit?.productName || ""}
            errorMessage={(errors.product_id?.value?.message || errors.product_id?.message )}
          />
          <TextField
            value={productPriceToEdit ? productPriceToEdit.oldPrice : ""}
            className="text-white-800 opacity-80"
            label="Valor antigo do produto"
            disabled
          />
          <Controller
            name="metric"
            control={control}
            render={({ field }) => (
              <CurrencyTextField
                label="Valor novo do produto"
                markAsRequired
                className="text-white-800"
                errorMessage={errors.metric?.message}
                {...field}
              />
            )}
          />
        </form>
      )}
    />
  )
}

export default ModalToEditProduct
